module.exports = __webpack_public_path__ + "static/enterprise_applications_and_solutions-3485aad8ec0ec1b05e72eae8dbb8ab52.jpg";